// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/enums.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/enums.proto.
 */
export const file_anu_cat_app_enums = /*@__PURE__*/
  fileDesc("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", [file_patch_go]);

/**
 * Describes the enum anu.cat_app.AcademicCareerCode.
 */
export const AcademicCareerCodeSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 0);

/**
 * Academic Career
 *
 * @generated from enum anu.cat_app.AcademicCareerCode
 */
export const AcademicCareerCode = /*@__PURE__*/
  tsEnum(AcademicCareerCodeSchema);

/**
 * Describes the enum anu.cat_app.SiteType.
 */
export const SiteTypeSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 1);

/**
 * @generated from enum anu.cat_app.SiteType
 */
export const SiteType = /*@__PURE__*/
  tsEnum(SiteTypeSchema);

/**
 * Describes the enum anu.cat_app.SiteStatus.
 */
export const SiteStatusSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 2);

/**
 * @generated from enum anu.cat_app.SiteStatus
 */
export const SiteStatus = /*@__PURE__*/
  tsEnum(SiteStatusSchema);

/**
 * Describes the enum anu.cat_app.StateTransition.
 */
export const StateTransitionSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 3);

/**
 * @generated from enum anu.cat_app.StateTransition
 */
export const StateTransition = /*@__PURE__*/
  tsEnum(StateTransitionSchema);

/**
 * Describes the enum anu.cat_app.SiteRoleID.
 */
export const SiteRoleIDSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 4);

/**
 * @generated from enum anu.cat_app.SiteRoleID
 */
export const SiteRoleID = /*@__PURE__*/
  tsEnum(SiteRoleIDSchema);

/**
 * Describes the enum anu.cat_app.OrgRoleID.
 */
export const OrgRoleIDSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 5);

/**
 * @generated from enum anu.cat_app.OrgRoleID
 */
export const OrgRoleID = /*@__PURE__*/
  tsEnum(OrgRoleIDSchema);

/**
 * Describes the enum anu.cat_app.DeliveryModeCode.
 */
export const DeliveryModeCodeSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 6);

/**
 * Course Delivery Mode
 *
 * @generated from enum anu.cat_app.DeliveryModeCode
 */
export const DeliveryModeCode = /*@__PURE__*/
  tsEnum(DeliveryModeCodeSchema);

/**
 * Describes the enum anu.cat_app.SiteAction.
 */
export const SiteActionSchema = /*@__PURE__*/
  enumDesc(file_anu_cat_app_enums, 7);

/**
 * @generated from enum anu.cat_app.SiteAction
 */
export const SiteAction = /*@__PURE__*/
  tsEnum(SiteActionSchema);

